import type {
  QueryParams,
  FilterQuery,
  SortQuery,
  SortOption,
} from './DefaultQueryFormatter'
import DefaultQueryFormatter from './DefaultQueryFormatter'
import { storyblokDateFormat } from '~/utils/storyblok'

type StaticSortOption = string

export default class EventsQueryFormatter extends DefaultQueryFormatter {
  /**
   * Converts the given URL params into a Storyblok query filter object
   *
   * For events, we only want to show events from 'now' forward,
   * so need to apply an extra filter for that
   */
  override getFilterQuery(params: QueryParams = {}): FilterQuery {
    const date = new Date()
    date.setHours(0, 0, 0, 0)

    return {
      filter_query: {
        ...(super.getFilterQuery(params)?.filter_query || {}),
        date_end: { gt_date: storyblokDateFormat(date) },
      },
    }
  }

  /**
   * Get the static sort options available for this type.
   *
   * @returns Array of static sort options
   */
  getStaticSortOptions(): StaticSortOption[] {
    return ['content.regular_event:asc']
  }

  override getSortOptions(_params: QueryParams = {}): SortOption[] {
    return [
      { label: 'Date', value: 'content.date_start:asc' },
      { label: 'A-Z', value: 'name:asc' },
      { label: 'Z-A', value: 'name:desc' },
    ]
  }

  override getSortQuery(params: QueryParams = {}): SortQuery {
    const res = super.getSortQuery(params).sort_by
    const staticSort = this.getStaticSortOptions()
    return {
      sort_by:
        res.includes('date_start') && staticSort
          ? [staticSort, res].join(',')
          : res,
    }
  }
}
